import './Details.scss';
import { useState, useEffect } from 'react';
import axios from 'axios';
import { useRef } from 'react';
import { Link } from 'react-router-dom';
import ganesh_ji from '../../assets/ganesh_ji.png';



// const formatTime = (time, mode) => {
//   if (!time || typeof time !== 'string') return "N/A";

//   const [timePart, extra] = time.split(', ');
//   const [hourMin, ampm] = timePart.split(' ');
//   let [hour, minute] = hourMin.split(':').map(Number);
//   const isPM = time.toLowerCase().includes('pm');

//   if (mode === '12') {
//     const suffix = isPM ? 'PM' : 'AM';
//     hour = hour % 12 || 12;
//     return `${hour}:${minute.toString().padStart(2, '0')} ${suffix}${extra ? ', ' + extra : ''}`;
//   }

//   if (mode === '24') {
//     return time;
//   }

//   if (mode === '24+') {
//     if (isPM && hour < 12) hour += 12;
//     if (!isPM && hour === 12) hour = 0;
//     return `${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}${extra ? ', ' + extra : ''}`;
//   }

//   return time;
// };




const formatTime = (timeStr, mode = "12") => {
  if (!timeStr || typeof timeStr !== "string" || timeStr.trim() === "") return "N/A";

  const parts = timeStr.split(":").map(Number);
  const hour = parts[0];
  const minute = parts[1];
  const second = parts[2];

  // If any required part is missing, return "N/A"
  if (isNaN(hour) || isNaN(minute) || (mode === "24+" && isNaN(second))) {
    return "N/A";
  }
  

  if (mode === "12") {
    const suffix = hour >= 12 ? "PM" : "AM";
    const hour12 = hour % 12 === 0 ? 12 : hour % 12;
    return `${hour12.toString().padStart(2, "0")}:${minute
      .toString()
      .padStart(2, "0")} ${suffix}`;
  }

  if (mode === "24") {
    return `${hour.toString().padStart(2, "0")}:${minute
      .toString()
      .padStart(2, "0")}`;
  }

  if (mode === "24+") {
    return `${hour.toString().padStart(2, "0")}:${minute
      .toString()
      .padStart(2, "0")}:${second.toString().padStart(2, "0")}`;
  }

  return timeStr;
};



const Details = () => {

    const [lagnaData, setLagnaData] = useState(null);
   const [timeFormat, setTimeFormat] = useState('12');
   const [panchang, setPanchang] = useState(null);

   const [sentDate, setSentDate] = useState('');  //to save the date seperately as the api has other format of date
const [sentTime, setSentTime] = useState('');  // to save the time seperately as the api has other format of time


//for showing and hiding 'read more' and the logic behind it
const [showFullPanchang, setShowFullPanchang] = useState(false);
const [showFullLagna, setShowFullLagna] = useState(false);
const [showFullFestival, setShowFullFestival] = useState(false);



const [isPanchangOverflow, setIsPanchangOverflow] = useState(false);
const [isLagnaOverflow, setIsLagnaOverflow] = useState(false);
const [isFestivalOverflow, setIsFestivalOverflow] = useState(false);

const panchangRef = useRef();
const lagnaRef = useRef();
const festivalRef = useRef();

useEffect(() => {
  if (panchangRef.current && panchangRef.current.scrollHeight > 180) {
    setIsPanchangOverflow(true);
  }
  if (lagnaRef.current && lagnaRef.current.scrollHeight > 180) {
    setIsLagnaOverflow(true);
  }
  if (festivalRef.current && festivalRef.current.scrollHeight > 280) {
    setIsFestivalOverflow(true);
  }
}, [panchang, lagnaData]);



//for card 1
  useEffect(() => {
  const fetchPanchang = async () => {
    try {
      const currentdate = new Date().toISOString().split('T')[0]; // YYYY-MM-DD format
      const res = await axios.get(`https://core-c343.onrender.com/api/panchanga?date=${currentdate}`);
      setPanchang(res.data);
    } catch (error) {
      console.error('Failed to fetch Panchang data', error);
    }
  };

  fetchPanchang();
}, []);


//for card 2
  useEffect(() => {
    const fetchLagnaKundali = async () => {
      try {
        const dateObj = new Date();
        const date = dateObj.toISOString().split('T')[0]; // YYYY-MM-DD
        const time = dateObj.toTimeString().split(' ')[0].slice(0, 5); // HH:MM

         setSentDate(date); // save it in state
        setSentTime(time);
        const location = 'kolkata'; 

        const res = await axios.get(
          `https://core-c343.onrender.com/api/kundli?date=${date}T${time}:00&location=${location}`
        );

        setLagnaData(res.data);
      } catch (error) {
        console.error('Failed to fetch Lagna Kundali', error);
      }
    };

    fetchLagnaKundali();
  }, []);


  //card 3: Upcoming Festivals
const [festivalData, setFestivalData] = useState([]);

useEffect(() => {
  const fetchFestivals = async () => {
    try {
      const year = new Date().getFullYear();
      const res = await axios.get(`https://core-c343.onrender.com/api/hindu-festival?year=${year}`);
      const data = res.data.months;

      // Flatten the festival object into a simple array
      const allFestivals = [];
      for (let month in data) {
        data[month].forEach(festival => {
          allFestivals.push(festival);
        });
      }

      // Optional: Sort by date
      allFestivals.sort((a, b) => new Date(a.date) - new Date(b.date));

      setFestivalData(allFestivals);
    } catch (error) {
      console.error('Failed to fetch festival data:', error);
    }
  };

  fetchFestivals();
}, []);


// function convertUtcToIstTimeOnly(utcTimeStr, mode = '12') {
//   if (!utcTimeStr) return 'N/A';

//   const [time, modifier] = utcTimeStr.trim().split(' ');
//   let [hours, minutes] = time.split(':').map(Number);

//   if (modifier.toUpperCase() === 'PM' && hours !== 12) hours += 12;
//   if (modifier.toUpperCase() === 'AM' && hours === 12) hours = 0;

//   const today = new Date();
//   const date = new Date(Date.UTC(today.getUTCFullYear(), today.getUTCMonth(), today.getUTCDate(), hours, minutes));

//   const options = {
//     timeZone: 'Asia/Kolkata',
//     hour: '2-digit',
//     minute: '2-digit',
//     hour12: mode === '12',
//   };

//   return date.toLocaleTimeString('en-IN', options);
// }

  return (
    <div className="details">
      {/* Card 1: Panchang */}
      <section className="card">
        <Link to="/panchang/dainik" className="Card-header">
          <h2>Panchang for Today</h2>
          <span>{panchang?.location}</span>
        </Link>

        <div className="card-body">
          <div className="timee">
            <button onClick={() => setTimeFormat('12')}>12 Hour</button>
              <button onClick={() => setTimeFormat('24')}>24 Hour</button>
              <button onClick={() => setTimeFormat('24+')}>24 Plus</button>
          </div>
          {/* <img
            src="https://edenflorist.com/wp-content/uploads/2018/01/zodiak4.png"
            alt="Zodiac"
          /> */}
        </div>

        <div className={`more-details1 ${showFullPanchang ? 'expanded' : ''}`} ref={panchangRef}>
          <span> 
            {new Date(sentDate).toLocaleDateString('en-US', {
              year: 'numeric',
              month: 'long',
              day: 'numeric'
            })}</span>
          <ul>
            <li><strong>Sunrise:</strong> {formatTime(panchang?.sunrise, timeFormat)}</li>
            <li><strong>Sunset:</strong> {formatTime(panchang?.sunset, timeFormat)}</li>
            <li><strong>Moonrise:</strong> {formatTime(panchang?.moonrise, timeFormat)}</li>
            <li><strong>Moonset:</strong> {formatTime(panchang?.moonset, timeFormat)}</li>
            <li><strong>Tithi:</strong> {panchang?.tithi?.name} ({formatTime(panchang?.tithi?.start, timeFormat)} - {formatTime(panchang?.tithi?.end, timeFormat)})</li>
            <li><strong>Paksha:</strong> {panchang?.paksha}</li>
            <li><strong>Nakshatra:</strong> {panchang?.nakshatra?.name} ({formatTime(panchang?.nakshatra?.start, timeFormat)} - {formatTime(panchang?.nakshatra?.end, timeFormat)})</li>
            <li><strong>Lunar Month:</strong> {panchang?.lunarMonth}</li>
            <li><strong>Yoga:</strong> {panchang?.yoga?.name} ({formatTime(panchang?.yoga?.start, timeFormat)} - {formatTime(panchang?.yoga?.end, timeFormat)})</li>
            <li><strong>Karana:</strong>
              <ul>
                {panchang?.karana?.map((k, i) => (
                  <li key={i}>{k.name} – ends at {formatTime(k.end, timeFormat)}</li>
                ))}
              </ul>
            </li>
            <li><strong>Weekday:</strong> {panchang?.weekday}</li>
            <li><strong>Brahma Muhurta:</strong> {formatTime(panchang?.muhurta?.brahma?.start, timeFormat)} - {formatTime(panchang?.muhurta?.brahma?.end, timeFormat)}</li>
            <li><strong>Abhijit Muhurta:</strong> {formatTime(panchang?.muhurta?.abhijit?.start, timeFormat)} - {formatTime(panchang?.muhurta?.abhijit?.end, timeFormat)}</li>
            <li><strong>Rahu Kaal:</strong> {formatTime(panchang?.rahuKalam?.start, timeFormat)} - {formatTime(panchang?.rahuKalam?.end, timeFormat)}</li>
              <li><strong>Amrit Kalam:</strong> {formatTime(panchang?.amritKalam?.start, timeFormat)} - {formatTime(panchang?.amritKalam?.end, timeFormat)}</li>

              <li><strong>Yamaganda Kalam:</strong> {formatTime(panchang?.yamagandaKalam?.start, timeFormat)} - {formatTime(panchang?.yamagandaKalam?.end, timeFormat)}</li>

              <li><strong>Varjyam:</strong> {formatTime(panchang?.varjyam?.start, timeFormat)} - {formatTime(panchang?.varjyam?.end, timeFormat)}</li>

              <li><strong>Durmuhurta:</strong>
                <ul>
                  {panchang?.durMuhurtas?.map((d, i) => (
                    <li key={i}>{formatTime(d.start, timeFormat)} - {formatTime(d.end, timeFormat)}</li>
                  ))}
                </ul>
              </li>

              <li><strong>Vikram Samvat:</strong> {panchang?.vikramSamvat?.formatted}</li>
              <li><strong>Shaka Samvat:</strong> {panchang?.shakaSamvatDetails?.formatted}</li>
              <li><strong>Gujarati Samvat:</strong> {panchang?.gujaratiSamvatDetails?.formatted}</li>

          </ul>

        </div>

        {isPanchangOverflow && (
            <div className="footer">
              <div className="btn" onClick={() => setShowFullPanchang(!showFullPanchang)}>
                {showFullPanchang ? 'Show Less' : 'Read More'}
              </div>
            </div>
          )}
      </section>

      {/* Card 2: Lagna Kundali */}
      <section className="card">
        <Link to="/jyotish/kundali" className="Card-header">
          <h2>Lagna Kundali</h2>
          <span>Kolkata, India</span>
        </Link>

        <div className="card-body">
          {/* <img
            src="https://edenflorist.com/wp-content/uploads/2018/01/zodiak4.png"
            alt="Lagna"
          /> */}
          <img
            src={ganesh_ji}
            alt="Kundali"
          />
        </div>

        <div className={`more-details3 ${showFullLagna ? 'expanded' : ''}`} ref={lagnaRef}>
          <span>
            {new Date(sentDate).toLocaleDateString('en-US', {
              year: 'numeric',
              month: 'long',
              day: 'numeric'
            })} at {sentTime}
          </span>

          <table className='lagna-table'>
            <tbody>
              {lagnaData?.rashiChart?.map((planets, index) => (
                <tr key={index}>
                  <td>{planets.planet}</td>
                  <td>{planets.longitude}</td>
                  <td>{planets.nakshatra}</td>
                  <td>{planets.nakshatraLord}</td>
                  <td>{planets.subLord}</td>
                  <td>{planets.rulerOf}</td>
                  <td>{planets.isIn}</td>
                  <td>{planets.relationship}</td>
                  <td>{planets.bhavaOwner}</td>
                  <td>{planets.dignity}</td>
                  
                  {/* <td>{planets.retrograde === true ? 'True' : 'False'}</td> */}
                </tr>
              ))}
            </tbody>
          </table>
        </div>

       

        {isLagnaOverflow && (
            <div className="footer">
              <div className="btn" onClick={() => setShowFullLagna(!showFullLagna)}>
                {showFullLagna ? 'Show Less' : 'Read More'}
              </div>
            </div>
          )}
      </section>

      {/* Card 3: Upcoming Festivals */}
      <section className="card">
        <Link to="/festival/hindufest" className="Card-header">
          <h2>Upcoming Festivals</h2>
          <span>Kolkata, India</span>
        </Link>

        <div className={`more-details2 ${showFullFestival ? 'expanded' : ''}`} ref={festivalRef}>
          <ul>
            {festivalData.map((festival, index) => (
              <li key={index}>
                <strong>{festival.name}</strong> – {new Date(festival.date).toLocaleDateString('en-US', {
                  year: 'numeric',
                  month: 'long',
                  day: 'numeric'
                })}
              </li>
            ))}
          </ul>
        </div>

        {isFestivalOverflow && (
          <div className="footer">
            <div className="btn" onClick={() => setShowFullFestival(!showFullFestival)}>
              {showFullFestival ? 'Show Less' : 'Read More'}
            </div>
          </div>
        )}
      </section>

    </div>
  );
};

export default Details;

